import { defineMessages } from 'react-intl'

export const ConsumerAssetSubtypeErrorMessages = defineMessages({
  errorMessage: {
    id: 'Pages.ConsumerAssetSubtype.Form.errorMessage',
    description: 'Consumer Asset Subtype Error Message',
  },
})
